export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '正版授权',
      description: '所有漫画均为官方正版授权，画质高清，阅读体验一流，支持原创作者，让每一部好作品获得应有的回报。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速更新',
      description: '与日本同步更新，最新章节第一时间送达。追更不再等待，热门漫画每日更新，永不断更承诺。',
    },
    {
      icon: 'ri-device-line',
      title: '多端畅读',
      description: '支持手机、平板、电脑无缝切换阅读。智能同步阅读进度，随时随地继续你的漫画之旅。',
    },
    {
      icon: 'ri-download-cloud-line',
      title: '离线下载',
      description: '支持漫画离线下载，地铁、飞机上也能畅快阅读。智能管理下载空间，不占手机存储。',
    },
    {
      icon: 'ri-translate-2',
      title: '专业汉化',
      description: '资深翻译团队精心汉化，保留原作精髓。地道中文表达，让你沉浸在原汁原味的漫画世界中。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '个性化推荐',
      description: '智能推荐算法，根据你的阅读喜好精准推荐漫画。越读越懂你，发现更多心仪的好作品。',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 id="features-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择 jm漫画
          </h2>
          <p className="text-sm text-foreground-500 mt-2">六大核心优势，打造极致漫画阅读体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat, index) => (
            <div
              key={index}
              className="flex gap-4 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${feat.icon} text-lg text-primary-600`}></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1.5">{feat.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feat.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}